import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Slider from "react-slick";
import { NetworkAxios, ProgramSetupAxios } from "../../API";
import Avatar from "../../shared/commonComponents/Avatar";
import { TextInput } from "../../shared/inputs";
import Moment from "react-moment";
import ShowMore from "../../shared/commonComponents/ShowMore";
import ReadMore from "../../shared/commonComponents/ReadMore";

const Feeds = () => {
  const userDetails = useSelector((state) => state.auth.loggedInUser);
  const [feeds, setFeeds] = useState([]);
  const [lcoalFeeds, setLocalFeeds] = useState([]);
  const [filters, setFilters] = useState([]);
  const [shwoFeeds, setShowFeeds] = useState(false);
  const [filterBy, setFilterBy] = useState("All");
  const [missionList, setMissionList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(2);
  const [pageSize, setPageSize] = useState(10);
  const [activeShowMore, setActiveShowMore] = useState(true);

  useEffect(() => {
    let filterMissionId = filters.filter((x) => x.missionName === filterBy);
    if (filterMissionId) {
      let filteredFeeds =
        filterBy === "All"
          ? lcoalFeeds
          : lcoalFeeds.filter(
            (item) =>
              item.missionId === filterMissionId[0].id || item.missionId === 0
          );
      setFeeds(filteredFeeds);
    } else setFeeds(lcoalFeeds);
    setTotalPages(2);
    getAllFeeds(1, pageSize);
  }, [filterBy]);

  const toogleFeeds = () => {
    setShowFeeds(!shwoFeeds);
  };

  useEffect(() => {
    getAllFeeds(currentPage, pageSize);
    getOfferingMissoinList();
  }, []);

  const getAllFeeds = (page, size) => {
    let filterMissionId = filters.filter((x) => x.missionName === filterBy);
    let filterId = filterMissionId.length > 0 ? filterMissionId[0].id : 0;

    NetworkAxios.get(
      `Feeds/getallfeeds/${userDetails.offeringId}/${filterId}/${page}/${size}`
    )
      .then(function (res) {
        setFeeds([]);
        setLocalFeeds([]);

        let combinedFeeds = res.data;

        if (lcoalFeeds.length > 0 && page > 1) {
          combinedFeeds = [...lcoalFeeds, ...res.data];

          if (res.data.length === pageSize) {
            setTotalPages(totalPages + 1);
          }
        }
        if (res.data.length < pageSize) {
          setActiveShowMore(false);
        } else {
          setActiveShowMore(true);
        }

        setCurrentPage(page);
        setLocalFeeds(combinedFeeds);
        setFeeds(combinedFeeds);
      })
      .catch(function (er) {
        console.log(er);
      });
  };

  const loadMoreFeeds = () => {
    let nextPage = currentPage + 1;

    if (nextPage <= totalPages) {
      getAllFeeds(nextPage, pageSize);
    }
  };

  const getOfferingMissoinList = () => {
    ProgramSetupAxios.get(
      "/OfferingMission/getmissionsbyoffering/" + userDetails.offeringId
    )
      .then(function (response) {
        setMissionList(response.data);
        setFilters([{ id: 0, missionName: "All" }, ...response.data]);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      createFeed();
    }
  };

  const [newFeed, setNewFeed] = useState("");
  const handleFeed = (e) => {
    setNewFeed(e.target.value);
  };
  const createFeed = () => {
    let filterMissionId = filters.filter((x) => x.missionName === filterBy);
    if (newFeed !== "") {
      var data = {
        userId: userDetails.userId,
        offeringId: userDetails.offeringId,
        stageId: userDetails.stageId,
        missionId: filterMissionId[0].id,
        teamId: userDetails.teamId,
        activityId: userDetails.offeringId,
        activityBy: userDetails.offeringUserId,
        activityFor: userDetails.offeringUserId,
        activityType: "Feed",
        feedText: newFeed,
        actionRoute: "",
      };
      NetworkAxios.post("Feeds", data)
        .then(function () {
          setNewFeed("");
          getAllFeeds(1, pageSize);
        })
        .catch(function (er) {
          console.log(er);
        });
    }
  };

  const feedContent = () => {
    return (
      <>
        <div className="feeds-header">
          <div className="feed-title" onClick={() => toogleFeeds()}>
            Feed
            <div className="title-arrow"></div>
          </div>
        </div>
        <div className="filter-container">
          <Slider
            dots={false}
            infinite={false}
            speed={500}
            initialSlide={0}
            slidesToShow={2}
            slidesToScroll={2}
          >
            {filters.map((item) => {
              let isActive = item === filterBy ? "active" : "";
              return (
                <div key={item.id} className="filter-wrapper">
                  <div
                    className={
                      item.missionName === filterBy
                        ? "filteredMission filter" + isActive
                        : "filter " + isActive
                    }
                    onClick={() => setFilterBy(item.missionName)}
                  >
                    {item.missionName}
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
        <div className="feeds-body scroll-content">
          <div>
            {feeds &&
              feeds.map((item, index) => {
                return (
                  <div
                    className="feed-item"
                    key={"feed-item-" + index}
                    id={"feed-item-" + index}
                  >
                    <Avatar {...item.userProfile} className="small py-2" />
                    <div>
                      <div className="text">
                        <ReadMore
                          text={item.feedText}
                          name="Read"
                          maxLength={79}
                        />
                      </div>
                      <div className="feed-timestamp">
                        <Moment
                          // add={{ hours: 24 }}
                          format="MM/DD HH:mm A"
                          local={true}
                        >
                          {item.createdOn + "Z"}
                        </Moment>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
          {feeds.length >= pageSize && activeShowMore && (
            <ShowMore onClick={loadMoreFeeds} />
          )}
        </div>
        <div className="feeds-footer">
          {userDetails.roleId === 5 && (
            <div className="d-flex align-items-center mb-2">
              <Avatar {...userDetails} frame="coach" className="small" />
              <TextInput
                className="text m-0 ml-2"
                onKeyDown={handleKeyDown}
                onChange={handleFeed}
                maxLength={200}
                value={newFeed}
                placeholder={`Post a message to ${filterBy}`}
              />
              <div
                onClick={() => {
                  createFeed();
                }}
                className="submitfeed"
              ></div>
            </div>
          )}
          <div className="footer-content"></div>
        </div>
      </>
    );
  };

  let showFeedsClass = shwoFeeds ? " opened content-height" : " closed ";
  return shwoFeeds ? (
    <div className={"feeds-overlay " + showFeedsClass}>{feedContent()}</div>
  ) : (
    feedContent()
  );
};

export default Feeds;
